"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const lodash_1 = require("lodash");
class Baseline {
    constructor(baselineJson) {
        if (baselineJson === null || baselineJson === undefined) {
            this.baseline = 1;
        }
        else if (typeof baselineJson === 'number') {
            this.baseline = baselineJson;
        }
        else {
            this.baseline = baselineJson;
        }
    }
    getBaselineHazard(timeInDays) {
        /* If it's a number then it's not a function of the age datum in the data argument so return it */
        if (typeof this.baseline === 'number') {
            return this.baseline;
        }
        else {
            const closestTimeIndex = lodash_1.sortedIndexBy(this.baseline, {
                time: timeInDays,
                baselineHazard: 1,
            }, baselineObj => {
                return baselineObj.time;
            });
            return this.baseline[closestTimeIndex === this.baseline.length
                ? closestTimeIndex - 1
                : closestTimeIndex].baselineHazard;
        }
    }
}
exports.Baseline = Baseline;
//# sourceMappingURL=baseline.js.map